@if (isVisible) {
  <div class="environment-banner" title="Test Environment">
    <!-- <div class="environment-banner__border environment-banner__border--top"></div> -->
    <div class="environment-banner__content">
      @for (i of repeatCount; track $index) {
        <span class="environment-banner__text">Test Environment</span>
      }
    </div>
    <!-- <div class="environment-banner__border environment-banner__border--bottom"></div> -->
  </div>
}
